const handleCommonRediection = (teamUserCheck) => {
  if (teamUserCheck) {
    setTimeout(() => {
      window.location.replace(
        `${process.env.REACT_APP_TEAMBUZZ_AUTH_URL}?next=${process.env.REACT_APP_AUTH_REDIRECT_URL}`
      );
    }, 1000);
  } else {
    setTimeout(() => {
      window.location.replace(
        `${process.env.REACT_APP_AUTH_URL}?next=${process.env.REACT_APP_AUTH_REDIRECT_URL}`
      );
    }, 1000);
  }
};

export default handleCommonRediection;
